export type CookieSameSite = 'Lax' | 'Strict' | 'None';

export type CookieOptions = {
	path?: string
	domain?: string
	secure?: boolean
	sameSite?: CookieSameSite
	expires?: Date
	maxAge?: number // seconds
};

export const getCookie = (name: string): string | null => {
	if (typeof document === 'undefined') return null;

	const value: string = `; ${document.cookie}`;
	const parts: string[] = value.split(`; ${encodeURIComponent(name)}=`);
	if (parts.length === 2) return parts.pop()?.split(';')?.shift() ?? null;
	return null;
};

export const setCookie = (name: string, value: string, options: CookieOptions = {}): void => {
	if (typeof document === 'undefined') return;

	const {
		path = '/',
		domain,
		secure,
		sameSite,
		expires,
		maxAge,
	} = options;

	const parts: string[] = [`${encodeURIComponent(name)}=${encodeURIComponent(value)}`];

	if (typeof maxAge === 'number') parts.push(`Max-Age=${Math.floor(maxAge)}`);
	if (expires instanceof Date) parts.push(`Expires=${expires.toUTCString()}`);
	if (domain) parts.push(`Domain=${domain}`);
	if (path) parts.push(`Path=${path}`);
	if (sameSite) parts.push(`SameSite=${sameSite}`);
	if (secure) parts.push('Secure');

	document.cookie = parts.join('; ');
};

export const removeCookie = (name: string, options: CookieOptions = {}): void => {
	// Note: to reliably delete, domain/path must match how cookie was set.
	setCookie(name, '', {
		...options,
		path: options.path ?? '/',
		expires: new Date(0),
		maxAge: 0,
	});
};
